import { render, staticRenderFns } from "./allMenu.vue?vue&type=template&id=2bc27d9e"
import script from "./allMenu.vue?vue&type=script&lang=js"
export * from "./allMenu.vue?vue&type=script&lang=js"
import style0 from "./allMenu.vue?vue&type=style&index=0&id=2bc27d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports